import { render, staticRenderFns } from "./Wp_jd_hot_sku_model.vue?vue&type=template&id=f537b130&scoped=true&"
import script from "./Wp_jd_hot_sku_model.vue?vue&type=script&lang=js&"
export * from "./Wp_jd_hot_sku_model.vue?vue&type=script&lang=js&"
import style0 from "./Wp_jd_hot_sku_model.vue?vue&type=style&index=0&id=f537b130&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f537b130",
  null
  
)

export default component.exports